import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: true,
  sidebarCollapsed: false,
  activeModule: 'dashboard',
  breadcrumbs: [{ label: 'Dashboard', path: '/dashboard' }],
  pageTitle: 'Dashboard',
  mobileMenuOpen: false,
  modalOpen: null,
  notificationPanelOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    toggleSidebarCollapsed: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setActiveModule: (state, action) => {
      state.activeModule = action.payload;
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload;
    },
    addBreadcrumb: (state, action) => {
      const exists = state.breadcrumbs.find((b) => b.path === action.payload.path);
      if (!exists) {
        state.breadcrumbs.push(action.payload);
      }
    },
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    },
    toggleMobileMenu: (state) => {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    openModal: (state, action) => {
      state.modalOpen = action.payload;
    },
    closeModal: (state) => {
      state.modalOpen = null;
    },
    toggleNotificationPanel: (state) => {
      state.notificationPanelOpen = !state.notificationPanelOpen;
    },
    resetUI: (state) => {
      state.sidebarOpen = true;
      state.sidebarCollapsed = false;
      state.activeModule = 'dashboard';
      state.breadcrumbs = [{ label: 'Dashboard', path: '/dashboard' }];
      state.pageTitle = 'Dashboard';
      state.mobileMenuOpen = false;
      state.modalOpen = null;
      state.notificationPanelOpen = false;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  toggleSidebarCollapsed,
  setActiveModule,
  setBreadcrumbs,
  addBreadcrumb,
  setPageTitle,
  toggleMobileMenu,
  openModal,
  closeModal,
  toggleNotificationPanel,
  resetUI,
} = uiSlice.actions;

export default uiSlice.reducer;
